import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import ResponsiveTopNavigation from '../../components/navigation/ResponsiveTopNavigation';
import ServiceModeToggle from '../../components/navigation/ServiceModeToggle';
import ContentFilterTabs from '../restaurant-details/components/ContentFilterTabs';
import SectionScrollNavigation from '../../components/navigation/SectionScrollNavigation';
import LocationHeader from './components/LocationHeader';
import SearchBar from './components/SearchBar2';
import HeroBanner from './components/HeroBanner';
import OffersSection from './components/OffersSection';
import CouponsSection from './components/CouponsSection';
import DeliveryTrackingSection from './components/ActiveOrderSection';
import Footer from 'components/Footer';
import MarketsSection from './components/MarketsSection';
import HomeMarketsFeedSection from './components/HomeMarketsFeedSection';
import MarketCategoriesSection from './components/MarketCategoriesSection';
import ContentFilterTabs2 from './components/ContentFilterTabs2';
import SearchBar2 from './components/SearchBar2';
import SearchBarSuggest2 from './components/SearchBarSuggest2';

const MarketHomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>الماركت - يسلمو</title>
      </Helmet>


      <div className="min-h-screen bg-[#F8F8F8] smooth-scroll">
        <ResponsiveTopNavigation />

        <main className="pt-16">
          {/* <LocationHeader /> */}
          <div className="flex flex-col lg:flex-row lg:items-center">
            <div className="lg:w-[30%]">
              <ServiceModeToggle />
            </div>

            <div className="lg:flex-1">
              <SearchBarSuggest2 />
            </div>
          </div>
          <ContentFilterTabs2 />
          <HeroBanner />
          <SectionScrollNavigation />
          <MarketCategoriesSection />

          {/* <OffersSection /> */}
          <CouponsSection />
          <HomeMarketsFeedSection
            sectionId="home-new-markets"
            title="جديد على يسلمو"
            feedKey="new"
          />
          <HomeMarketsFeedSection
            sectionId="home-lowest-delivery-markets"
            title="توصيل سريع"
            feedKey="lowest-delivery"
          />
          <MarketsSection />
          {/* <Footer /> */}
        </main>
      </div>
    </>
  );
};

export default MarketHomePage;